import React, { useState } from "react";
import { TextField, Typography, Box, Checkbox, FormControlLabel, Button, Dialog, DialogTitle, DialogContent, FormControl, InputLabel, Select, MenuItem, IconButton, Grid } from "@mui/material";
import { Add as AddIcon, Delete as DeleteIcon } from "@mui/icons-material";
import LocationSelector from "../LocationSelector"; // Import the reusable Mapbox component

const Step1AppDetails = ({ appDetails = {}, setAppDetails }) => {
  const [isMapOpen, setIsMapOpen] = useState(false);

  const handleChange = (field, value) => {
    setAppDetails({ ...appDetails, [field]: value });
  };

  const handleOvertureDataSourceChange = (index, field, value) => {
    const currentSources = appDetails.overtureds || [];
    const updatedSources = [...currentSources];
    updatedSources[index] = { ...updatedSources[index], [field]: value };
    setAppDetails({ ...appDetails, overtureds: updatedSources });
  };

  const addOvertureDataSource = () => {
    const currentSources = appDetails.overtureds || [];
    const newSource = { type: "", url: "" };
    setAppDetails({
      ...appDetails,
      overtureds: [...currentSources, newSource],
    });
  };

  const removeOvertureDataSource = (index) => {
    const currentSources = appDetails.overtureds || [];
    const updatedSources = currentSources.filter((_, i) => i !== index);
    setAppDetails({ ...appDetails, overtureds: updatedSources });
  };

  const handleGeolocationUpdate = (lat, lng) => {
    handleChange("geolocation", { lat, lng });
    setIsMapOpen(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        mx: "auto",
      }}
    >
      <Typography variant="h6" gutterBottom>
        App Details
      </Typography>
      <Typography variant="body2" sx={{ mb: 3 }}>
        Provide the basic information for your monitoring application.
      </Typography>
      <TextField label="App Name" fullWidth value={appDetails.name || ""} onChange={(e) => handleChange("name", e.target.value)} helperText="Example: Smart City Traffic Monitoring" sx={{ mb: 2 }} />
      <TextField label="App Description" fullWidth multiline rows={4} value={appDetails.description || ""} onChange={(e) => handleChange("description", e.target.value)} />

      <FormControlLabel control={<Checkbox checked={appDetails.geobased || false} onChange={(e) => handleChange("geobased", e.target.checked)} />} label="Is this app geolocation-based?" />
      {appDetails.geobased && (
        <>
          <TextField
            label="Latitude"
            fullWidth
            value={appDetails.geolocation?.lat || ""}
            onChange={(e) => handleChange("geolocation", { ...appDetails.geolocation, lat: e.target.value })}
            sx={{ mb: 2 }}
          />
          <TextField
            label="Longitude"
            fullWidth
            value={appDetails.geolocation?.lng || ""}
            onChange={(e) => handleChange("geolocation", { ...appDetails.geolocation, lng: e.target.value })}
            sx={{ mb: 2 }}
          />
          <Button variant="contained" onClick={() => setIsMapOpen(true)}>
            Select Location on Map
          </Button>
        </>
      )}

      <Typography variant="h6" sx={{ mt: 3, mb: 2 }}>
        OvertureMap Data Source
      </Typography>
      <Box sx={{ mb: 2, width : "100%" }}>
        {(appDetails.overtureds || []).map((source, index) => (
          <Grid container spacing={2} key={index} sx={{ mb: 2, alignItems: "center", width: "100%" }}>
            <Grid item xs={2}>
              <FormControl fullWidth>
                <InputLabel>Data Source Type</InputLabel>
                <Select value={source.type || ""} onChange={(e) => handleOvertureDataSourceChange(index, "type", e.target.value)} label="Data Source Type">
                  <MenuItem value="building">Building</MenuItem>
                  <MenuItem value="transportation">Transportation</MenuItem>
                  <MenuItem value="places">Places</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={9}>
              <TextField
                label="Data Source URL"
                fullWidth
                value={source.url || ""}
                onChange={(e) => handleOvertureDataSourceChange(index, "url", e.target.value)}
                helperText="Enter the URL for your map data source"
              />
            </Grid>
            <Grid item xs={1}>
              <IconButton onClick={() => removeOvertureDataSource(index)} color="error" size="small">
                <DeleteIcon />
              </IconButton>
            </Grid>
          </Grid>
        ))}
        <Button variant="outlined" startIcon={<AddIcon />} onClick={addOvertureDataSource} sx={{ mt: 1 }}>
          Add Data Source
        </Button>
      </Box>

      <Dialog open={isMapOpen} onClose={() => setIsMapOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>Select Location</DialogTitle>
        <DialogContent>
          <LocationSelector initialLocation={appDetails.geolocation} onLocationSelect={handleGeolocationUpdate} />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default Step1AppDetails;
